<template>
  <div class="header-section">
    <!-- คำเตือน -->
    <v-row>
      <v-col cols="12">
        <div class="text-right pa-2">
          <span class="font-weight-bold error--text">
            * รายการร้องขอข้อมูลบุคคลจากส่วนกลางกรณีย้ายเข้ามาแล้วแต่ไม่ปรากฎชื่อ
          </span>
        </div>
      </v-col>
    </v-row>

    <!-- ปุ่มดำเนินการ -->
    <v-row>
      <v-col cols="12">
        <div class="text-right pa-2">
          <v-btn 
            color="primary" 
            @click="$emit('add-personnel')"
            class="mr-2"
          >
            <v-icon left>mdi-plus-circle-outline</v-icon>
            ขอเพิ่มบุคลากร (พนักงานราชการ) จากแห่งอื่น กรณีย้าย
          </v-btn>

          <v-btn
            color="info"
            @click="$emit('export-data')"
          >
            <v-icon left>mdi-printer</v-icon>
            ส่งออกข้อมูล
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "HeaderSection",
};
</script>

<style scoped>
.header-section {
  margin-bottom: 16px;
}
</style>